<template>
  <div class="MenuSide">
    <div class="menuSideTopBox"></div>
    <el-menu
      :default-active="$route.path"
      :router="true"
      :unique-opened="true"
      class="menu-side"
      :collapse="isCollapse"
      background-color="#fff"
      active-text-color="#333333"
      text-color="#000"
    >
      <!--User reservation-->
      <div class="menu-side-title">
        <p>{{ $t("pages.wording.reserveFunction") }}</p>
        <!--預約功能-->
      </div>
      <div>
        <el-menu-item index="/MyReservation" style="text-align: left">
          <i class="el-icon-tickets"></i>
          <span slot="title">{{ $t("pages.wording.reserve") }}</span
          ><!--我的預約單-->
        </el-menu-item>
        <el-menu-item index="/SearchReservation" style="text-align: left">
          <i class="el-icon-search"></i>
          <span slot="title">{{ $t("pages.wording.searchReserve") }}</span
          ><!--預約單查詢-->
        </el-menu-item>
      </div>
      <div class="menu-side-title">
        <p>{{ $t("pages.wording.releaseOrder") }}</p>
        <!--放行單-->
      </div>
      <div>
        <el-menu-item index="/VendorReleaseOrder" style="text-align: left">
          <i class="el-icon-user"></i>
          <span slot="title">{{ $t("pages.wording.myReleaseOrder") }}</span
          ><!--我的放行單-->
        </el-menu-item>
      </div>
      <div>
        <el-menu-item index="/SearchVendorReleaseOrder" style="text-align: left">
          <i class="el-icon-user"></i>
          <span slot="title">{{ $t("pages.wording.searchReleaseOrder") }}</span
          ><!--放行單查詢-->
        </el-menu-item>
      </div>
    </el-menu>
  </div>
</template>

<script>
export default {
  name: "MenuSide",
  data() {
    return {
      isCollapse: false,
    }
  },
}
</script>

<style>
.menu-side {
  background-color: #fff;
  border-right: solid 0px #e6e6e6;
  position: absolute;
  top: 55px;
  bottom: 0px;
  text-align: left;
  overflow-y: auto;
}
.menu-side:not(.el-menu--collapse) {
  width: 299px;
  /*border-right: solid 0px #e6e6e6;*/
}
.menu-side-title {
  color: #00a0e9;
  font-size: 16px;
  font-weight: bold;
  padding: 30px 0 0 15px;
}
.menuSideTopBox {
  height: 55px;
  width: 100%;
  background-color: #00a0e9;
  box-shadow: 0 5px 8px -4px #909399e0;
}
.el-menu-item {
  padding-left: 30px;
}
.el-menu-item:hover {
  outline: 0 !important;
  background-color: #e8e8e8 !important;
}
.el-menu-item.is-active {
  background-color: #e6f1fc !important;
  color: #00a0e9 !important;
  font-weight: 800;
}
.el-submenu__title:focus,
.el-submenu__title:hover {
  outline: 0 !important;
  background-color: #f5f5f5 !important;
}
.menu-border-bottom {
  background-color: #ddd;
  height: 1px;
}
.el-menu-item [class^="el-icon-"] {
  font-size: 25px;
  margin-right: 25px;
}
.el-submenu [class^="el-icon-"] {
  margin-right: 25px;
}
.el-menu-item i {
  color: #00a0e9;
}
.el-aside {
  overflow: hidden;
}
</style>
